export const ACTION_GET_PRODUCT_REVIEW_BY_ID = '/ProductReviews/GetProductReviewById';